<template>
  <div>
    <HeaderCreditor header="เจ้าหนี้" :img_header="header_image" link_back="creditor/all"/>
    <MenuCreditor/>
    <ReportCreditorList/>
  </div>
</template>

<script>
import MenuCreditor from '@/components/admin/creditor/menucreditor/MenuCreditor.vue'
import ReportCreditorList from '@/components/admin/creditor/reportcreditor/ReportCreditorList.vue'
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import HeaderImage from "@/assets/creditor_1.png";

export default {
  name:'reportCreditor',
  components:{
    HeaderCreditor,
    MenuCreditor,
    ReportCreditorList,
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>
